import { useEffect, useState } from "react";
import { profileService } from "@/services/profileService";
import { useAuth } from "@/context/AuthContext";

export const useProfileMetrics = () => {
  const { token } = useAuth();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!token) return;

    const fetchMetrics = async () => {
      try {
        const result = await profileService.getMetrics(token);
        setData(result);
      } catch (err) {
        setError(err);
        console.error("Error fetching profile metrics:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, [token]);

  return { data, loading, error };
};
